import { Pipe, PipeTransform } from '@angular/core';
import { abbreviateNumber } from '@aptitude/shared-vanilla';

@Pipe({
    name: 'abbreviatedNumberWithSuffix',
    standalone: false
})
export class AbbreviatedNumberWithSuffixPipe implements PipeTransform {
  /**
   * @description Abbreviate a number down to our common significant figures
   * and add proper suffix e.g. 1000 = 1k, 1512 = 1.5k
   *
   * @param {number} val Original value
   * @example
   * 1555555 | abbreviatedNumberWithSuffix -- result: 1.5m
   *
   * @param {number} [significantDecimalAt=1000] The number place to show single decimal.
   * @example
   * significantDecimalAt = 1000 then 1500 = 1.5k,
   * @example
   * significantDecimalAt = 1000000 then 1500 = 1k
   * @example
   * significantDecimalAt = 1000000 then 1500000 = 1.5m
   *
   * @return string
   */
  transform(val: number, significantDecimalAt = 1000): string {
    return abbreviateNumber(val, significantDecimalAt);
  }
}
